export const batchTicketInvestLinkScreenName = 'Oportunidades recebidas';
export const batchTicketInvestWhatsAppDefaultNumber = 'https://wa.me/5511918702006';
